import { engagementAppGroupIdStructuralTemplateCanvasTemplatesData } from "../engagementAppGroupIdStructuralTemplateCanvasTemplatesData";
import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  engagementAppGroupIdStructuralTemplateCanvasTemplatesData,
];
